import * as DialogPrimitive from "@radix-ui/react-dialog";

export function Dialog({
  open,
  onOpenChange,
  children,
  size = "default",
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  size?: "default" | "lg";
}) {
  const maxWidth = size === "lg" ? "max-w-[min(95vw,680px)]" : "max-w-[min(95vw,480px)]";
  const maxHeight = size === "lg" ? "max-h-[min(90vh,640px)]" : "max-h-[85vh]";

  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-40 bg-black/70" />
        <DialogPrimitive.Content
          className={`fixed top-1/2 left-1/2 z-50 w-full -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-[16px] border border-[var(--color-border-modal)] bg-[var(--color-bg-modal)] p-6 text-[var(--color-text-primary)] shadow-xl focus:outline-none ${maxWidth} ${maxHeight}`}
        >
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

export function DialogTitle({ children }: { children: React.ReactNode }) {
  return (
    <DialogPrimitive.Title className="mb-4 text-[20px] font-medium text-[var(--color-text-primary)]">
      {children}
    </DialogPrimitive.Title>
  );
}

export function DialogClose() {
  return (
    <DialogPrimitive.Close className="absolute top-4 right-4 rounded-[var(--radius-sm)] p-1 text-[var(--color-text-secondary)] transition-colors hover:text-[var(--color-text-primary)]">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M12 4L4 12M4 4l8 8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </DialogPrimitive.Close>
  );
}
